/* OS JV – Select Flavors (scoped, no global pollution) */
(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function loadScriptOnce(src, attrName, attrValue, cb) {
    if (document.querySelector('script[' + attrName + '="' + attrValue + '"]')) {
      cb && cb();
      return;
    }
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.setAttribute(attrName, attrValue);
    s.onload = function () { cb && cb(); };
    document.head.appendChild(s);
  }

  function osjfOrdinal(n) {
    var s = ["th", "st", "nd", "rd"];
    var v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  }

  function osjfFormatDate(d) {
    var months = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];

    var mm = months[d.getMonth()];
    var day = d.getDate();
    var yyyy = d.getFullYear();

    return mm + " " + day + osjfOrdinal(day) + " " + yyyy;
  }

  function initOSJF_MobileDates(root) {
    if (!root) return;

    var wrap = qs(root, "[data-osjf-mobile-dates]");
    if (!wrap) return;

    if (wrap.dataset.osjfDatesInit === "1") return;
    wrap.dataset.osjfDatesInit = "1";

    var restockedEl = qs(root, "[data-osjf-restocked-date]");
    var selloutEl = qs(root, "[data-osjf-sellout-date]");
    if (!restockedEl || !selloutEl) return;

    var today = new Date();
    var sellout = new Date(today.getTime() + (7 * 24 * 60 * 60 * 1000));

    restockedEl.textContent = osjfFormatDate(today);
    selloutEl.textContent = osjfFormatDate(sellout);
  }

  function initOSJF_Lottie(root) {
    if (!root) return;

    var iconEls = qsa(root, '[data-osjf-lottie]');
    if (!iconEls.length) return;

    loadScriptOnce(
      'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js',
      'data-osjf-lottie-lib',
      '1',
      function () {
        if (!window.lottie) return;

        iconEls.forEach(function (iconEl) {
          var url = iconEl.getAttribute('data-lottie-url');
          if (!url) return;

          var container = iconEl.querySelector('.osjf-mobile-box__callout-lottie');
          if (!container) return;

          // Prevent duplicate animations (theme editor / section reload safety)
          if (iconEl.__osjfLottieAnim) {
            try { iconEl.__osjfLottieAnim.destroy(); } catch (e) {}
            iconEl.__osjfLottieAnim = null;
          }

          // Clear any prior SVG markup
          container.innerHTML = '';

          iconEl.__osjfLottieAnim = window.lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: url,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid meet',
              progressiveLoad: true
            }
          });
        });
      }
    );
  }

  function toInt(v, fallback) {
    var n = parseInt(String(v || ""), 10);
    return isNaN(n) ? fallback : n;
  }

  function parseVariantIdList(str) {
    var out = [];
    var raw = String(str || "").trim();
    if (!raw) return out;

    // Supports: "123,456" or "123:2, 456:1"
    raw.split(/[,|\n]/g).forEach(function (part) {
      var p = String(part || "").trim();
      if (!p) return;

      var seg = p.split(":");
      var id = toInt(seg[0], 0);
      if (!id) return;

      var qty = 1;
      if (seg.length > 1) {
        qty = toInt(seg[1], 1);
        if (qty <= 0) qty = 1;
      }

      out.push({ id: id, quantity: qty });
    });

    return out;
  }

  function mergeItems(baseItems, extraItems) {
    var map = {};
    var out = [];

    function keyOf(it) {
      var sp = it && it.selling_plan ? String(it.selling_plan) : "";
      return String(it.id || "") + "::" + sp;
    }

    function addOne(it) {
      if (!it || !it.id || !it.quantity) return;
      var k = keyOf(it);

      if (!map[k]) {
        map[k] = {
          id: it.id,
          quantity: it.quantity
        };
        if (it.selling_plan) map[k].selling_plan = it.selling_plan;

        out.push(map[k]);
      } else {
        map[k].quantity += it.quantity;
      }
    }

    (baseItems || []).forEach(addOne);
    (extraItems || []).forEach(addOne);

    return out;
  }

  function getFreebieItemsForTotal(totalBags, freebies1, freebies2, freebies3, freebies4) {
    var freebies = [];

    if (totalBags >= 1) freebies = freebies.concat(parseVariantIdList(freebies1));
    if (totalBags >= 2) freebies = freebies.concat(parseVariantIdList(freebies2));
    if (totalBags >= 3) freebies = freebies.concat(parseVariantIdList(freebies3));
    if (totalBags >= 4) freebies = freebies.concat(parseVariantIdList(freebies4));

    return freebies;
  }

  function buildItemsFromState(state, planId) {
    var items = [];
    Object.keys(state.counts).forEach(function (variantId) {
      var qty = state.counts[variantId] || 0;
      if (qty <= 0) return;

      var line = {
        id: toInt(variantId, 0),
        quantity: qty
      };

      if (planId) {
        line.selling_plan = toInt(planId, 0);
      }

      items.push(line);
    });
    return items;
  }

  function buildCartAddUrl(items, returnToPath) {
    var parts = [];

    for (var i = 0; i < items.length; i++) {
      var it = items[i] || {};
      if (!it.id || !it.quantity) continue;

      parts.push("items[" + i + "][id]=" + encodeURIComponent(String(it.id)));
      parts.push("items[" + i + "][quantity]=" + encodeURIComponent(String(it.quantity)));

      if (it.selling_plan) {
        parts.push("items[" + i + "][selling_plan]=" + encodeURIComponent(String(it.selling_plan)));
      }
    }

    parts.push("return_to=" + encodeURIComponent(returnToPath || "/checkout"));

    return "/cart/add?" + parts.join("&");
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(payload || {})
    }).then(function (r) {
      if (!r.ok) throw new Error("Request failed: " + r.status);
      return r.json().catch(function () { return {}; });
    });
  }

    function parseDiscountCodes(str) {
    var out = [];
    var raw = String(str || "").trim();
    if (!raw) return out;

    raw.split(/[,|\n]/g).forEach(function (part) {
      var c = String(part || "").trim();
      if (!c) return;
      out.push(c);
    });

    return out;
  }

  function getDiscountCodesForTotal(totalBags, d1, d2, d3, d4) {
    var codes = [];
    if (totalBags >= 1) codes = codes.concat(parseDiscountCodes(d1));
    if (totalBags >= 2) codes = codes.concat(parseDiscountCodes(d2));
    if (totalBags >= 3) codes = codes.concat(parseDiscountCodes(d3));
    if (totalBags >= 4) codes = codes.concat(parseDiscountCodes(d4));

    // de-dupe (case-insensitive)
    var seen = {};
    var out = [];
    codes.forEach(function (c) {
      var k = String(c || "").toLowerCase();
      if (!k || seen[k]) return;
      seen[k] = true;
      out.push(c);
    });

    return out;
  }

  function buildDiscountRedirectUrl(codes, redirectPath) {
    var list = (codes || []).filter(Boolean);
    if (!list.length) return "";

    // Shopify supports /discount/CODE1,CODE2?redirect=/checkout
    return "/discount/" + encodeURIComponent(list.join(",")) + "?redirect=" + encodeURIComponent(redirectPath || "/checkout");
  }

  function initOne(root) {
    if (!root || root.dataset.osjfInit === "1") return;
    root.dataset.osjfInit = "1";

    var params = new URLSearchParams(window.location.search);

    var defaultRequired = toInt(root.getAttribute("data-default-required") || "1", 1);
    var requiredQty = toInt(params.get("quantity"), defaultRequired);

    var plan = String(params.get("plan") || "subscription").toLowerCase();
    var isOtp = plan === "otp" || plan === "one-time" || plan === "onetime";

    var plan1 = root.getAttribute("data-plan-1") || "";
    var plan2 = root.getAttribute("data-plan-2") || "";
    var plan3 = root.getAttribute("data-plan-3") || "";
    var plan4 = root.getAttribute("data-plan-4") || "";

    var clearCart = (root.getAttribute("data-clear-cart") || "true") === "true";

    var freebies1 = root.getAttribute("data-freebies-1") || "";
    var freebies2 = root.getAttribute("data-freebies-2") || "";
    var freebies3 = root.getAttribute("data-freebies-3") || "";
    var freebies4 = root.getAttribute("data-freebies-4") || "";
    var freebiesOtp1 = root.getAttribute("data-freebies-otp-1") || "";
    var freebiesOtp2 = root.getAttribute("data-freebies-otp-2") || "";
    var freebiesOtp3 = root.getAttribute("data-freebies-otp-3") || "";
    var freebiesOtp4 = root.getAttribute("data-freebies-otp-4") || "";

    var disc1 = root.getAttribute("data-discount-1") || "";
    var disc2 = root.getAttribute("data-discount-2") || "";
    var disc3 = root.getAttribute("data-discount-3") || "";
    var disc4 = root.getAttribute("data-discount-4") || "";
    var discOtp1 = root.getAttribute("data-discount-otp-1") || "";
    var discOtp2 = root.getAttribute("data-discount-otp-2") || "";
    var discOtp3 = root.getAttribute("data-discount-otp-3") || "";
    var discOtp4 = root.getAttribute("data-discount-otp-4") || "";

    // Allow up to 16 total bags (even if URL quantity=1)
    var maxQty = 16;

    // Pick plan by FINAL qty (subscription only) - decided at checkout
    function getSellingPlanIdForQty(qty) {
      if (isOtp) return "";
      if (qty === 1) return plan1;
      if (qty === 2) return plan2;
      if (qty === 3) return plan3;
      return plan4;
    }

    // Elements
    var titleEl = qs(root, "[data-osjf-title]");
    var subEl = qs(root, "[data-osjf-sub]");
    var backBtn = qs(root, "[data-osjf-back]");
    var ctaBtn = qs(root, "[data-osjf-cta]");
    var stickyWrap = qs(root, "[data-osjf-sticky-cta-wrap]");
    var stickyCtaBtn = qs(root, "[data-osjf-sticky-cta]");
    var stickyCtaLeft = qs(root, "[data-osjf-sticky-cta-left]");
    var noteEl = qs(root, "[data-osjf-note]");

    var progressTextEl = qs(root, "[data-osjf-progress-text]");
    var barFillEl = qs(root, "[data-osjf-bar-fill]");

    var itemEls = qsa(root, "[data-osjf-item]");
    var giftsWrap = qs(root, "[data-osjf-gifts-wrap]") || qs(root, ".osjv-gifts");

    // State
    var state = {
      required: Math.min(maxQty, Math.max(1, requiredQty)), // minimum required to enable checkout
      max: maxQty,                                         // maximum allowed selection
      counts: {},
      total: 0
    };

    function recalcTotal() {
      var t = 0;
      Object.keys(state.counts).forEach(function (k) {
        t += toInt(state.counts[k], 0);
      });
      state.total = t;
    }

    function setHeader() {
      if (titleEl) {
        titleEl.textContent = "Select at least " + state.required + " " + (state.required === 1 ? "bag" : "bags");
      }

      if (subEl) {
        if (isOtp) {
          subEl.textContent = "Try it once (no autoship). Pick your flavor.";
        } else {
          subEl.textContent = "Subscribe & save. Pick your flavors.";
        }
      }

      if (noteEl) {
        if (isOtp) {
          noteEl.textContent =
            "No autoship. You can check out once you’ve selected " +
            state.required +
            (state.required === 1 ? " bag." : " bags.");
        } else {
          noteEl.textContent = "Subscription will be applied at checkout.";
        }
      }

      // If Try Once (OTP) is selected, do NOT show gifts on Select Flavors
      if (giftsWrap) {
        giftsWrap.style.display = isOtp ? "none" : "";
      }
    }

    function syncStickyCta() {
      if (!stickyWrap || !stickyCtaBtn || !ctaBtn) return;

      // Mirror disabled state
      stickyCtaBtn.disabled = !!ctaBtn.disabled;

      // Mirror left label text
      var mainLeft = ctaBtn.querySelector("[data-osjf-cta-left]");
      if (stickyCtaLeft && mainLeft) {
        stickyCtaLeft.textContent = mainLeft.textContent || stickyCtaLeft.textContent;
      }
    }

    function updateUI() {
      recalcTotal();

      // Update each row qty + enable/disable plus/minus
      itemEls.forEach(function (row) {
        if (row.getAttribute("data-sold-out") === "1") return;

        var vid = row.getAttribute("data-variant-id");
        var qtyEl = qs(row, "[data-osjf-row-qty]");
        var minusBtn = qs(row, "[data-osjf-minus]");
        var plusBtn = qs(row, "[data-osjf-plus]");

        var q = toInt(state.counts[vid], 0);
        if (qtyEl) qtyEl.textContent = String(q);

        if (minusBtn) minusBtn.disabled = q <= 0;

        // Plus disabled when you already hit the MAX (16)
        if (plusBtn) plusBtn.disabled = state.total >= state.max;
      });

      // Progress
      var pct = Math.min(100, Math.round((state.total / state.max) * 100));
      if (barFillEl) barFillEl.style.width = pct + "%";

      if (progressTextEl) {
        progressTextEl.textContent = state.total + "/" + state.max + " selected";
      }

      // CTA enable/label
      var canCheckout = state.total >= state.required;

      if (ctaBtn) {
        ctaBtn.disabled = !canCheckout;

        if (!canCheckout) {
          var remaining = state.required - state.total;
          ctaBtn.querySelector("[data-osjf-cta-left]").textContent =
            remaining === 1 ? "Select 1 more bag" : ("Select " + remaining + " more bags");
        } else {
          ctaBtn.querySelector("[data-osjf-cta-left]").textContent = "Proceed to Checkout";
        }
      }

      syncStickyCta();
    }

    function handleAdd(variantId) {
      if (state.total >= state.max) return;
      state.counts[variantId] = toInt(state.counts[variantId], 0) + 1;
      updateUI();
    }

    function handleRemove(variantId) {
      var cur = toInt(state.counts[variantId], 0);
      if (cur <= 0) return;
      state.counts[variantId] = cur - 1;
      updateUI();
    }

    // Wire rows
    itemEls.forEach(function (row) {
      var vid = row.getAttribute("data-variant-id");
      var isSoldOut = row.getAttribute("data-sold-out") === "1";

      if (isSoldOut) return;

      state.counts[vid] = 0;

      var minusBtn = qs(row, "[data-osjf-minus]");
      var plusBtn = qs(row, "[data-osjf-plus]");

      if (minusBtn) {
        minusBtn.addEventListener("click", function () {
          handleRemove(vid);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener("click", function () {
          handleAdd(vid);
        });
      }
    });

    // Back
    if (backBtn) {
      backBtn.addEventListener("click", function () {
        // Prefer history back; fallback to home
        if (window.history && window.history.length > 1) window.history.back();
        else window.location.href = "/";
      });
    }

    // Sticky CTA click -> triggers the real CTA click (no duplicate checkout code)
    if (stickyCtaBtn) {
      stickyCtaBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (!ctaBtn) return;
        if (ctaBtn.disabled) return;

        // Delegate to the real CTA handler
        ctaBtn.click();
      });
    }

    // BOGOS helpers
    // BOGOS URL is chosen from the FINAL selected bag count:
    // 1 bag -> BOGOS URL 1
    // 2 bags -> BOGOS URL 2
    // 3 bags -> BOGOS URL 3
    // 4+ bags -> BOGOS URL 4
    var OSJF_BOGO_RELOAD_MARKER = "_osjv_bogo_reload";

    function normalizeBogoParamString(rawValue) {
      var normalized = String(rawValue || "").trim();

      if (!normalized) return "";

      if (normalized.indexOf("://") > -1) {
        try {
          normalized = new URL(normalized).search.replace(/^\?/, "");
        } catch (e) {}
      }

      var queryStartIndex = normalized.indexOf("?");

      if (queryStartIndex > -1) {
        normalized = normalized.slice(queryStartIndex + 1);
      }

      normalized = normalized.replace(/^[?&]+/, "");

      var hashIndex = normalized.indexOf("#");

      if (hashIndex > -1) {
        normalized = normalized.slice(0, hashIndex);
      }

      return normalized.trim();
    }

    function getBogoParamStringForQty(qty) {
      var raw = "";

      if (qty === 1) {
        raw = root.getAttribute("data-bogo-1") || "";
      } else if (qty === 2) {
        raw = root.getAttribute("data-bogo-2") || "";
      } else if (qty === 3) {
        raw = root.getAttribute("data-bogo-3") || "";
      } else {
        raw = root.getAttribute("data-bogo-4") || "";
      }

      return normalizeBogoParamString(raw);
    }

    function getAllConfiguredBogoKeys() {
      var keyMap = {};

      [1, 2, 3, 4].forEach(function (qty) {
        var params = new URLSearchParams(getBogoParamStringForQty(qty));

        params.forEach(function (value, key) {
          if (key && key !== OSJF_BOGO_RELOAD_MARKER) {
            keyMap[key] = true;
          }
        });
      });

      return Object.keys(keyMap);
    }

    function sameParamValues(paramsA, paramsB, key) {
      return (
        paramsA.getAll(key).join("\u0000") ===
        paramsB.getAll(key).join("\u0000")
      );
    }

    function reloadForBogoCheckout() {
      var configuredKeys = getAllConfiguredBogoKeys();

      if (!configuredKeys.length) {
        return false;
      }

      var effective = new URLSearchParams(
        getBogoParamStringForQty(state.total)
      );

      var current = new URLSearchParams(
        window.location.search
      );

      var needsReload = false;

      configuredKeys.forEach(function (key) {
        if (!sameParamValues(effective, current, key)) {
          needsReload = true;
        }
      });

      if (!needsReload) {
        return false;
      }

      var url = new URL(window.location.href);
      var savedCounts = {};

      Object.keys(state.counts).forEach(function (variantId) {
        var qty = toInt(state.counts[variantId], 0);

        if (qty > 0) {
          savedCounts[variantId] = qty;
        }
      });

      configuredKeys.forEach(function (key) {
        url.searchParams.delete(key);
      });

      effective.forEach(function (value, key) {
        if (key && key !== OSJF_BOGO_RELOAD_MARKER) {
          url.searchParams.append(key, value);
        }
      });

      url.searchParams.set(
        OSJF_BOGO_RELOAD_MARKER,
        JSON.stringify({
          mode: "checkout",
          counts: savedCounts,
          scrollX: Math.round(
            window.scrollX ||
            window.pageXOffset ||
            0
          ),
          scrollY: Math.round(
            window.scrollY ||
            window.pageYOffset ||
            0
          )
        })
      );

      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }

      window.location.replace(url.toString());

      return true;
    }

    function getBogoReloadState() {
      var raw = new URL(
        window.location.href
      ).searchParams.get(
        OSJF_BOGO_RELOAD_MARKER
      );

      if (!raw) return null;

      try {
        var parsed = JSON.parse(raw);

        return (
          parsed &&
          typeof parsed === "object"
        )
          ? parsed
          : null;
      } catch (e) {
        return null;
      }
    }

    function stripBogoReloadMarker() {
      var url = new URL(
        window.location.href
      );

      if (
        !url.searchParams.has(
          OSJF_BOGO_RELOAD_MARKER
        )
      ) {
        return;
      }

      url.searchParams.delete(
        OSJF_BOGO_RELOAD_MARKER
      );

      window.history.replaceState(
        {},
        "",
        url.pathname +
          (url.search || "") +
          url.hash
      );
    }

    function restoreBogoSelection(reloadState) {
      var savedCounts =
        reloadState &&
        reloadState.counts &&
        typeof reloadState.counts === "object"
          ? reloadState.counts
          : {};

      var remaining = state.max;

      itemEls.forEach(function (row) {
        if (
          row.getAttribute("data-sold-out") === "1"
        ) {
          return;
        }

        var variantId = row.getAttribute(
          "data-variant-id"
        );

        var qty = Math.max(
          0,
          toInt(
            savedCounts[variantId],
            0
          )
        );

        qty = Math.min(
          qty,
          remaining
        );

        state.counts[variantId] = qty;

        remaining -= qty;
      });

      recalcTotal();
    }

    function restoreBogoScroll(reloadState) {
      var scrollX = Number(
        reloadState &&
        reloadState.scrollX
      );

      var scrollY = Number(
        reloadState &&
        reloadState.scrollY
      );

      if (
        !isFinite(scrollX) ||
        !isFinite(scrollY)
      ) {
        return;
      }

      window.setTimeout(
        function () {
          window.scrollTo(
            Math.max(0, scrollX),
            Math.max(0, scrollY)
          );
        },
        0
      );
    }

    function getBogoAttributes(
      bogoParamString
    ) {
      var params = new URLSearchParams(
        bogoParamString || ""
      );

      var attributes = {};
      var hasAny = false;

      params.forEach(
        function (value, key) {
          if (
            !key ||
            key ===
              OSJF_BOGO_RELOAD_MARKER
          ) {
            return;
          }

          attributes[key] = value;
          hasAny = true;
        }
      );

      return hasAny
        ? attributes
        : null;
    }

    function fetchCartJSON() {
      return fetch(
        "/cart.js",
        {
          method: "GET",
          headers: {
            "Accept":
              "application/json",
            "X-Requested-With":
              "XMLHttpRequest"
          },
          credentials:
            "same-origin",
          cache:
            "no-store"
        }
      ).then(function (r) {
        if (!r.ok) {
          throw new Error(
            "Unable to read cart: " +
            r.status
          );
        }

        return r.json();
      });
    }

    function waitForBogoGift(
      knownItemCount
    ) {
      return new Promise(
        function (resolve) {
          var interval = 200;
          var maxWait = 6000;
          var elapsed = 0;

          function check() {
            fetchCartJSON()
              .then(
                function (cart) {
                  if (
                    typeof cart.item_count ===
                      "number" &&
                    cart.item_count >
                      knownItemCount
                  ) {
                    resolve(true);
                    return;
                  }

                  elapsed += interval;

                  if (
                    elapsed >=
                    maxWait
                  ) {
                    resolve(false);
                    return;
                  }

                  window.setTimeout(
                    check,
                    interval
                  );
                }
              )
              .catch(
                function () {
                  resolve(false);
                }
              );
          }

          window.setTimeout(
            check,
            interval
          );
        }
      );
    }

    function sumItemQuantities(items) {
      var total = 0;

      (items || []).forEach(
        function (item) {
          total += Math.max(
            0,
            toInt(
              item &&
                item.quantity,
              0
            )
          );
        }
      );

      return total;
    }

    function buildBogoCheckoutPath(
      bogoParamString
    ) {
      var normalized = String(
        bogoParamString || ""
      ).trim();

      if (!normalized) {
        return "/checkout";
      }

      var params =
        new URLSearchParams(
          normalized
        );

      var checkoutUrl =
        new URL(
          "/checkout",
          window.location.origin
        );

      params.forEach(
        function (value, key) {
          if (
            key &&
            key !==
              OSJF_BOGO_RELOAD_MARKER
          ) {
            checkoutUrl
              .searchParams
              .append(
                key,
                value
              );
          }
        }
      );

      return (
        checkoutUrl.pathname +
        checkoutUrl.search +
        checkoutUrl.hash
      );
    }

    async function runBogoCheckout(
      items,
      destinationUrl,
      bogoParamString
    ) {
      try {
        if (clearCart) {
          await postJSON(
            "/cart/clear.js",
            {}
          );
        }

        var cartBeforeAdd = null;

        try {
          cartBeforeAdd =
            await fetchCartJSON();
        } catch (e) {}

        await postJSON(
          "/cart/add.js",
          {
            items: items
          }
        );

        var cartAfterAdd = null;

        try {
          cartAfterAdd =
            await fetchCartJSON();
        } catch (e) {}

        var bogoAttributes =
          getBogoAttributes(
            bogoParamString
          );

        if (bogoAttributes) {
          var cartAfterAttributes =
            await postJSON(
              "/cart/update.js",
              {
                attributes:
                  bogoAttributes
              }
            );

          var latestCart =
            cartAfterAttributes ||
            cartAfterAdd;

          var knownCount =
            latestCart &&
            typeof latestCart.item_count ===
              "number"
              ? latestCart.item_count
              : null;

          var baselineCount =
            cartBeforeAdd &&
            typeof cartBeforeAdd.item_count ===
              "number"
              ? cartBeforeAdd.item_count
              : null;

          var expectedAddedQuantity =
            sumItemQuantities(
              items
            );

          var giftAlreadyPresent =
            knownCount !== null &&
            baselineCount !== null &&
            knownCount >
              baselineCount +
                expectedAddedQuantity;

          if (
            !giftAlreadyPresent &&
            knownCount !== null
          ) {
            await waitForBogoGift(
              knownCount
            );
          }
        }

        window.location.href =
          destinationUrl;
      } catch (error) {
        console.error(
          "OS JV Select Flavors: BOGOS checkout failed.",
          error
        );

        ctaBtn.disabled = false;

        syncStickyCta();
      }
    }

    // Checkout
    if (ctaBtn) {
      ctaBtn.addEventListener(
        "click",
        function () {
          recalcTotal();

          if (
            state.total <
            state.required
          ) {
            return;
          }

          // BOGOS needs its offer params present while this page is loaded.
          // If the correct quantity's params are not present yet,
          // reload once, restore the selected flavors, then resume checkout.
          if (
            reloadForBogoCheckout()
          ) {
            return;
          }

          var finalPlanId =
            getSellingPlanIdForQty(
              state.total
            );

          var items =
            buildItemsFromState(
              state,
              finalPlanId
            );

          // Auto-add freebies by total bags
          // - Subscription uses freebies1/2/3/4
          // - OTP uses freebiesOtp1/2/3/4
          var fb1 = isOtp
            ? freebiesOtp1
            : freebies1;

          var fb2 = isOtp
            ? freebiesOtp2
            : freebies2;

          var fb3 = isOtp
            ? freebiesOtp3
            : freebies3;

          var fb4 = isOtp
            ? freebiesOtp4
            : freebies4;

          var freebieItems =
            getFreebieItemsForTotal(
              state.total,
              fb1,
              fb2,
              fb3,
              fb4
            );

          items = mergeItems(
            items,
            freebieItems
          );

          if (!items.length) {
            return;
          }

          ctaBtn.disabled = true;

          syncStickyCta();

          // Discount codes by total bags
          // - Subscription and OTP keep their existing separate settings
          var dA = isOtp
            ? discOtp1
            : disc1;

          var dB = isOtp
            ? discOtp2
            : disc2;

          var dC = isOtp
            ? discOtp3
            : disc3;

          var dD = isOtp
            ? discOtp4
            : disc4;

          var codes =
            getDiscountCodesForTotal(
              state.total,
              dA,
              dB,
              dC,
              dD
            );

          var bogoParamString =
            getBogoParamStringForQty(
              state.total
            );

          var checkoutPath =
            buildBogoCheckoutPath(
              bogoParamString
            );

          var discountUrl =
            buildDiscountRedirectUrl(
              codes,
              checkoutPath
            );

          var destinationUrl =
            discountUrl ||
            checkoutPath;

          // If BOGOS is configured:
          // add via AJAX, apply BOGOS cart attributes,
          // wait for the BOGOS gift, then continue to checkout.
          if (bogoParamString) {
            runBogoCheckout(
              items,
              destinationUrl,
              bogoParamString
            );

            return;
          }

          // No BOGOS for this quantity.
          // Keep the original URL-based cart/add behavior.
          var addUrl =
            buildCartAddUrl(
              items,
              destinationUrl
            );

          if (clearCart) {
            window.location.href =
              "/cart/clear?return_to=" +
              encodeURIComponent(
                addUrl
              );

            return;
          }

          window.location.href =
            addUrl;
        }
      );
    }

    // If the page was reloaded to activate the correct BOGOS URL,
    // restore the shopper's selected flavors and automatically resume checkout.
    var bogoReloadState =
      getBogoReloadState();

    if (bogoReloadState) {
      restoreBogoSelection(
        bogoReloadState
      );

      stripBogoReloadMarker();

      updateUI();

      restoreBogoScroll(
        bogoReloadState
      );

      if (
        bogoReloadState.mode ===
          "checkout" &&
        ctaBtn &&
        state.total >=
          state.required &&
        !ctaBtn.disabled
      ) {
        window.setTimeout(
          function () {
            ctaBtn.click();
          },
          50
        );
      }
    } else {
      // Clean up a malformed/leftover temporary marker if one exists.
      // Actual BOGOS params are intentionally left untouched.
      stripBogoReloadMarker();
    }

    setHeader();
    updateUI();
    initOSJF_Lottie(root);
    initOSJF_MobileDates(root);

    // Sticky CTA visibility: show only when main CTA is out of viewport
    if (stickyWrap && ctaBtn && 'IntersectionObserver' in window) {
      try {
        var io = new IntersectionObserver(function (entries) {
          var entry = entries && entries[0];
          var inView = !!(entry && entry.isIntersecting);

          if (inView) {
            stickyWrap.setAttribute('hidden', '');
          } else {
            stickyWrap.removeAttribute('hidden');
            syncStickyCta();
          }
        }, {
          root: null,
          threshold: 0.15
        });

        io.observe(ctaBtn);
      } catch (e) {}
    } else if (stickyWrap && ctaBtn) {
      // Fallback: simple scroll check
      function isInViewport(el) {
        if (!el) return false;
        var r = el.getBoundingClientRect();
        return r.bottom > 0 && r.right > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight) && r.left < (window.innerWidth || document.documentElement.clientWidth);
      }

      function onScrollFallback() {
        var inView = isInViewport(ctaBtn);
        if (inView) stickyWrap.setAttribute('hidden', '');
        else {
          stickyWrap.removeAttribute('hidden');
          syncStickyCta();
        }
      }

      window.addEventListener('scroll', onScrollFallback, { passive: true });
      window.addEventListener('resize', onScrollFallback);
      onScrollFallback();
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-os-jv-select-flavors]')
      .forEach(function (root) {
        initOne(root);
      });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target) return;

    var root = evt.target.querySelector(
      '[data-os-jv-select-flavors]'
    );

    if (root) initOne(root);
  });
})();


/* ============================================================
   Gifts unlock (Select Flavors)
   - Mirrors Select Quantity gifts behavior
   - Unlocks based on total selected bags (sum of row qty)
   - Scoped to this section instance (no bleed)
   ============================================================ */
(function () {
  function initOSJF_GiftsUnlock() {
    const root = document.querySelector('[data-os-jv-select-flavors]');
    if (!root) return;

    // If Try Once (OTP) is selected, hide gifts and do not run unlock logic
    const params = new URLSearchParams(window.location.search);
    const plan = String(params.get("plan") || "").toLowerCase();
    const isOtp = plan === "otp" || plan === "one-time" || plan === "onetime";

    if (isOtp) {
      const giftsWrap = root.querySelector('[data-osjf-gifts-wrap]') || root.querySelector('.osjv-gifts');
      if (giftsWrap) giftsWrap.style.display = 'none';
      return;
    }

    const qtyNodes = () => Array.from(root.querySelectorAll('[data-osjf-row-qty]'));
    const giftNodes = () => Array.from(root.querySelectorAll('[data-osjf-gift]'));

    // Preload gifts state from Top Shop and enforce monotonic unlock:
    // gifts can unlock MORE, but never LESS than the carried state.
    function getCarriedQty() {
      // Prefer URL quantity, fallback to sessionStorage
      const urlQty = parseInt(String(params.get('quantity') || '').trim(), 10);
      if (Number.isFinite(urlQty) && urlQty > 0) return urlQty;

      try {
        const stored = parseInt(String(sessionStorage.getItem('osjv_gifts_qty_v1') || '').trim(), 10);
        if (Number.isFinite(stored) && stored > 0) return stored;
      } catch (e) {}

      return 0;
    }

    // Carried-over unlock FLOOR (from Top Shop).
    // Gifts can go up/down with selection, but never below this floor.
    const carriedFloorQty = getCarriedQty();

    function getCurrentSelectedTotal() {
      return qtyNodes().reduce((sum, el) => {
        const n = parseInt((el.textContent || '0').trim(), 10);
        return sum + (Number.isFinite(n) ? n : 0);
      }, 0);
    }

    function setGiftState(giftEl, isUnlocked) {
      const lockline = giftEl.querySelector('[data-osjf-gift-lockline]');
      const requires = parseInt(giftEl.getAttribute('data-requires-qty') || '0', 10);

      if (isUnlocked) {
        giftEl.classList.remove('is-locked');
        if (lockline) lockline.textContent = '';
      } else {
        giftEl.classList.add('is-locked');
        if (lockline) lockline.textContent = requires > 0 ? `${requires}+ Bags` : 'Unlock';
      }
    }

    function updateGifts() {
      const currentTotal = getCurrentSelectedTotal();

      // FLOOR rule: never allow gifts to drop below carried-over state
      const total = Math.max(carriedFloorQty, currentTotal);

      const gifts = giftNodes();
      if (!gifts.length) return;

      gifts.forEach((giftEl) => {
        const requires = parseInt(giftEl.getAttribute('data-requires-qty') || '0', 10);
        const unlocked = requires > 0 ? total >= requires : total > 0;
        setGiftState(giftEl, unlocked);
      });
    }

    // Run once on load
    updateGifts();

    // Update after +/- clicks (your main script updates row qty; we read after)
    root.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest
        ? e.target.closest('[data-osjf-plus],[data-osjf-minus]')
        : null;
      if (!btn) return;

      // We can clear the stored carry-over after first interaction;
      // the monotonic floor is now held in highestTotalSeen.
      try { sessionStorage.removeItem('osjv_gifts_qty_v1'); } catch (e) {}

      requestAnimationFrame(() => {
        updateGifts();
      });
    });

    // If your main script updates UI without click (rare), keep a lightweight observer.
    const obs = new MutationObserver(() => updateGifts());
    qtyNodes().forEach((n) => obs.observe(n, { childList: true, characterData: true, subtree: true }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOSJF_GiftsUnlock);
  } else {
    initOSJF_GiftsUnlock();
  }
})();